module.exports = __webpack_public_path__ + "static/media/Pedro.4ccb818d.jpg";